/**
 * Router Component
 *
 * Main application router using react-router-dom's useRoutes hook.
 * Renders route configuration defined in routes.tsx.
 */

import { useRoutes } from 'react-router-dom';
import { routes } from './routes';

export default function Router() {
  const element = useRoutes(routes);
  return element;
}
